import { Stack } from '@mui/material';

import { BlockTextField } from '../../ConfigFields/TextField';

const GS_PATHS_HELPER_TEXT = `Cloud storage path to the insurance card image.`;

export function InsuranceCardFormFields() {
  return (
    <Stack spacing={2}>
      <BlockTextField
        fieldName="config.gsPath"
        label="Cloud Storage Path"
        required
        helperText={GS_PATHS_HELPER_TEXT}
      />
    </Stack>
  );
}
